export default __webpack_public_path__ + "dad410f98e420bad3b53eda4b5f6aaaf.woff2";